import { getDoc, doc } from '@firebase/firestore'
import axios from 'axios'
import { arrayUnion, updateDoc } from 'firebase/firestore'
import { addToDrawPile, setCards, setGame } from '../reducers/gameReducer'

const baseUrl = process.env.NODE_ENV === 'production' ? 'https://us-central1-lightning-cards-45e03.cloudfunctions.net/widgets/api' : 'http://localhost:5001/lightning-cards-45e03/us-central1/widgets/api'

export const generateCards = async (id) => {
  const res = await axios.post(baseUrl + '/gencards', { id: id })
  return res.status
}

/**
 * update players in firestore
 * @param {*} db 
 * @param {*} displayName 
 * @param {*} dispatch 
 */
export const updatePlayerInFirestore = async (db, displayName, uid, gameRef) => {
  await updateDoc(gameRef, {
    [`players.${uid}`]: {
      displayName: displayName
    }
  })
}

export const updateGameStateFromFirestore = async (db, id, dispatch) => {
  const gameRef = doc(db, "games", id)
  const gameState = (await getDoc(gameRef)).data()
  dispatch(setGame({ ...gameState, id: gameRef.id }))
}

export const getCards = async (db, gameID, userID) => {
  const gameRef = doc(db, "games", gameID)
  const gameCards = (await getDoc(gameRef)).data().players[userID].cards
  return gameCards
}

export const drawACard = async (uid, gameRef, cards, dispatch) => {
  const cardToDraw = cards.slice(-1)[0]
  const newCards = cards.filter(c => c !== cardToDraw)
  await updateDoc(gameRef, {
    [`players.${uid}.cards`]: newCards,
    [`players.${uid}.remainingCards`]: newCards.length,
    drawPile: arrayUnion(cardToDraw)
  })
  dispatch(setCards({ uid, cards: newCards }))
  dispatch(addToDrawPile(cardToDraw))
}

export const getGameChanges = (reduxState, firestoreState) => {
  if (Object.keys(reduxState.players).length !== Object.keys(firestoreState.players).length) return 'PLAYERS_CHANGED'
}